/**
 * Wrapper for the Synergy library
 *
 * Enforces that the Synergy library is loaded via code splitting before it is used
 * This is to prevent the Synergy library from being included in the main bundle
 * See also the hook useLoadSynergy.ts
 * 
 * Keep in sync with the SynergyWrapper in the DomoWeb
 */

export default class SynergyWrapper {

  static _synergy;

  static async loadSynergy() {
    try {
      const synergy = await import('@domo/synergy')
      this._synergy = synergy.com.domo.synergy;
      return synergy;
    } catch(err) {
      console.error('Failed to load synergy library', err);
    }
  }

  static get synergy() {
    if (!this._synergy) {
      throw new Error('Synergy not initialized');
    } else {
      return this._synergy;
    }
  }

}